import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

export class PosWarning {
  pos: string;
  accountNumber: string;
  storeKey: string;
  comercialName: string;
  description: string;
  indicator: string;
  date: string;
  origin: string;
  detailError: string;

  constructor(
    storeKey: string,
    accountNumber: string,
    pos: string,
    comercialName: string,
    description: string,
    indicator: string,
    date: string,
    origin: string,
    detailError: string
  ) {
    this.storeKey = storeKey;
    this.accountNumber = accountNumber;
    this.pos = pos;
    this.comercialName = comercialName;
    this.description = description;
    this.indicator = indicator;
    this.date = date;
    this.origin = origin;
    this.detailError = detailError;
  }
}
